import { z } from 'zod';

import { nonEmptyString } from './data';

/** Source of truth for the `cases` user store table (see userStoreSchema.ts) */
export const caseSchema = z.object({
  caseId: z.number(),
  propertyId: z.number(),
  personId: z.number(),
  demand: nonEmptyString,
  demandCode: z.number(),
  createdBy: nonEmptyString,
  leadOfficer: nonEmptyString,
  isClosed: z.boolean(),
  closeReason: z.string().optional(),
  reported: nonEmptyString,
  created: nonEmptyString,
  updated: z.string().optional(),
  isVisitingProgramme: z.boolean(),
});

/** Source of truth for the `caseEvents` user store table (see userStoreSchema.ts) */
export const caseEventSchema = z.object({
  eventId: z.number(),
  caseId: z.number(),
  contactMethod: nonEmptyString,
  inOrOut: nonEmptyString,
  note: nonEmptyString,
  created: nonEmptyString,
  createdBy: nonEmptyString,
  reportedDate: nonEmptyString,
});

export const newCaseSchema = caseSchema;

export const newCaseEventSchema = caseEventSchema.extend({
  contactMethodCode: z.number(),
  inOrOutCode: z.number(),
});

export const closeCaseSchema = caseSchema.pick({ caseId: true, personId: true }).extend({
  closeReason: z.string().min(1),
  closeReasonId: z.string().min(1),
});
